<template>
<!-- HEADER -->
<header class="header">
  <div class="header_content">
    <div class="logo" style="background-color:#FFFFFF;width: auto;">
      <a href="index.html">
        <img src="../../assets/img/logo-marianne.svg" style="background-color:#FFFFFF;height: 65px !important;margin-left: 5px;" >
      </a>
      <a href="index.html">
        <img src="../../assets/img/logo_recevoirlatnt.png" style="background-color:#FFFFFF;" alt="ANFR">
      </a>
    </div>

    <!-- Affichage mode standard -->
    <div id="form" :class="{login: true}">
      <!-- Formulaire de connexion si utilisateur non connecté -->
      <div class="login_form" v-if="!userId">
        <div class="login_header">
          <p>Connectez-vous</p>
        </div>
        <form ref="signinForm" v-on:submit.prevent>
          <div class="form">
            <div class="form_group">
              <label for="user_id">E-mail</label>
              <input type="text" name="user_id" placeHolder="Identifiant, E-mail" v-model="identifiant" />
            </div>
            <div class="form_group">
              <label for="user_password">Mot de passe :</label>
              <input type="password" name="user_password" placeHolder="Mot de passe" v-model="password" />
              <router-link to="/lostpassword" class="forgot_password">Mot de passe oublié ?</router-link>
            </div>
            <div class="form_group">
              <button class="blue" type="submit" v-on:click="login">OK</button>
            </div>
            <div class="form_group">
              <button @click="toInscription" class="blue">S'inscrire</button>
            </div>
          </div>
        </form>
        <div class="error_message" v-if="errorEmptyField">
          <span>L'adresse courriel et le mot de passe sont obligatoires.</span>
        </div>
        <div class="error_message" v-if="errorAuthentification">
          <span>Identifiant, mot de passe incorrect ou utilisateur inactif</span>
        </div>
      </div>
      <!-- En-tête et déconnexion si utilisateur authentifié -->
      <div class="login_form flexrow" v-else>
        <img src="../../assets/img/user-white.svg" alt="user icon" width="24" height="24" />
        <div class="login_header">
          <p>{{userIdentifiant}}</p>
          <button @click="logout">Se déconnecter</button>
        </div>
      </div>
    </div>

    <!-- Affichage mode mobile -->
    <div id="mobileForm" class="login">
      <div class="login_form flexrow" v-if="!userId">
        <img src="../../assets/img/user-white.svg" alt="user icon" width="24" height="24" />
        <div class="login_header">
          <button class="blue" @click="openModal()">Se connecter</button>
        </div>
      </div>

      <!-- En-tête et déconnexion si utilisateur authentifié -->
      <div class="login_form flexrow" v-else>
        <img src="../../assets/img/user-white.svg" alt="user icon" width="24" height="24" />
        <div class="login_header">
          <p>{{userIdentifiant}}</p>
          <button @click="logout">Se déconnecter</button>
        </div>
      </div>
    </div>

    <!-- Modale de connexion (mode mobile) -->
    <div id="modaleConnexion" class="modal_container">
      <div class="modal_background">
        <div class="modal">
          <div class="modal_header">
            <h3>Connexion</h3>
            <span class="icon_close" @click="closeModal()"></span>
          </div>

          <div class="error_message" v-if="errorEmptyField">
            <span>L'adresse courriel et le mot de passe sont obligatoires.</span>
          </div>
          <div class="error_message" v-if="errorAuthentification">
            <span>Identifiant, mot de passe incorrect ou utilisateur inactif</span>
          </div>

          <div class="modal_content">
            <div class="form">
              <div class="form_group">
                <label for="user_id">E-mail</label>
                <input type="text" name="user_id" autocapitalize="none" placeHolder="Identifiant, E-mail" v-model="identifiant" />
              </div>
              <div class="form_group">
                <label for="user_password">Mot de passe :</label>
                <input type="password" name="user_password" placeHolder="Mot de passe" v-model="password" />
                <button class="modale_forgot_password" @click="toLostPassword">Mot de passe oublié ?</button>
              </div>
            </div>
          </div>

          <div class="modal_footer">
            <button v-on:click="login" class="button dark">Ok</button>
            <button @click="toInscription" class="button dark">S'inscrire</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</header>
</template>
<script>
import storeJs from 'store'
import axios from 'axios'
import * as eventTypes from '../../bus/event-types.js'
import EventBus from '../../bus'
export default {
  name: 'CrHeader',
  components: {},
  data() {
    return {
      identifiant: null,
      password: null,
      errorEmptyField: null,
      errorAuthentification: null,
      userId: storeJs.get('prtv:user-id'),
      userPartenaire: storeJs.get("prtv:user-partenaire"),
      userIdentifiant: storeJs.get("prtv:user-identifiant")
    }
  },
  mounted() {
    EventBus.$on(eventTypes.EVENT_USER_INFO, () => {
      this.userId = storeJs.get('prtv:user-id');
      this.userIdentifiant = storeJs.get('prtv:user-identifiant');
      this.userPartenaire = storeJs.get("prtv:user-partenaire");
    })
  },
  methods: {
    toInscription() {
      this.closeModal();
      this.$router.push('/authent')
    },

    toLostPassword() {
      this.closeModal();
      this.$router.push('/lostpassword');
    },
    login() {
      this.errorEmptyField = false;
      this.errorAuthentification = false;
      if (!this.identifiant || !this.password) {
        this.errorEmptyField = true;
      } else {
        // Connexion de l'utilisateur
        axios.post('/utilisateur/login', {
          identifiant: this.identifiant,
          password: this.password
        }).then(response => {
          if (response.data) {
            storeJs.set('prtv:user-id', response.data.id);
            storeJs.set('prtv:user-identifiant', response.data.identifiant);
            storeJs.set('prtv:user-notificationTnt', response.data.notificationtnt);
            storeJs.set('prtv:user-notificationLte', response.data.notificationlte);
            storeJs.set('prtv:user-nbJoursNotificationLte', response.data.nbjoursnotificationlte);

            this.identifiant = null;
            this.password = null;
            this.closeModal();
            //On vérifie si l'antenniste est charté dans vgs
            this.checkChart(response.data.siret)
          } else {
            this.errorAuthentification = true;
          }
        });

        // On récupère l'url de redirection pour le site recevoirlatnt
        axios.get('/application/redirectrecevoirtnt').then(response => {
          if(response.data.urlRedirect){
            storeJs.set('prtv:url-redirectRecevoirTnt',response.data.urlRedirect);
          }
        }).catch(error => {
          this.$notify({
            group: 'general-notification',
            type: 'error',
            text: "Erreur lors de la récupération de l'url \"recevoirlatnt\""
          })
          console.error('Redirection recevoir la tnt', error.response)
        })
      }
    },
    logout() {
      storeJs.remove('prtv:user-id');
      storeJs.remove('prtv:user-partenaire');
      storeJs.remove('prtv:user-identifiant');
      storeJs.remove('prtv:user-notificationTnt');
      storeJs.remove('prtv:user-notificationLte');
      storeJs.remove('prtv:user-nbJoursNotificationLte');
      storeJs.remove('prtv:url-redirectRecevoirTnt');
      EventBus.$emit(eventTypes.EVENT_USER_INFO);
      this.$router.push('/');
    },
    checkChart(siret) {
      axios.get('/antenniste' + '?siret=' + siret).then(response => {
        if (response.data && response.data.data.length > 0) {
          var antenniste = response.data.data[0]
          if (antenniste.idstatutcharte && antenniste.idstatutcharte != null) {
            this.partenaire = (antenniste.idstatutcharte.nom.toUpperCase() === 'OUI' ? true : false)
            storeJs.set('prtv:user-partenaire', this.partenaire);
          }
        }
        EventBus.$emit(eventTypes.EVENT_USER_INFO);
        // Redirection
        this.$router.push('cartographies');
      }).catch(() => {
        //on considère qu'il est pas charté
        storeJs.set('prtv:user-partenaire', false);
        EventBus.$emit(eventTypes.EVENT_USER_INFO);
        // Redirection
        this.$router.push('cartographies');
      })
    },

    openModal() {
      var modal = document.getElementById('modaleConnexion')
      var body = document.getElementsByTagName('body')[0]
      modal.classList.add('animation');
      body.classList.add('modal_active');
    },

    closeModal() {
      var modal = document.getElementById('modaleConnexion');
      var body = document.getElementsByTagName('body')[0];
      modal.classList.remove('animation')
      body.classList.remove('modal_active')
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#mobileForm {
  display: none;
}

.header {
  overflow: auto;
}
.login_form {
  display: flex !important;
}

.flexrow {
  flex-direction: row !important;
}

.flexrow .login_header {
  margin-left: 12px;
  text-align: right;
}

.login_header p {
  margin-bottom: 0px !important;
  font-size: 17px !important;
  font-weight: 400 !important;
}

.login_header button {
  background-color: transparent;
  padding: 0 0 0 0;
  font-size: 12px;
}

.login {
  height: 80 !important;
}

@media screen and (max-width: 800px) {
  #mobileForm {
    display: flex;
    align-items: center;
  }

  #form {
    display: none;
  }

  .form div {
    padding-bottom: 0;
  }
}

.logo img {
  height: 70px !important;
}

/* CSS modale connexion */
.modal_footer {
  display: flex;
  flex-direction: column;
}

.modale_forgot_password {
  color: #282828;
  font-weight: normal;
  font-size: 12px;
  background-color: transparent;
  text-align: right;
}

.error_message {
  color: #d9534f;
  font-size: 16px;
}
</style>
